module.exports = __webpack_public_path__ + "img/arrow_right_circle.4ebd2680.svg";